<template>
  <div>
    <div class="row l-m-b-16">
      <div class="col-6">
        <h2 class="l-header-2">Form HTML</h2>
        <br />
        <span class="section-disclaimer">
          We are rendering a script for you which you can add into your HTML app. Instructions are on the right, code you need to copy is below.
        </span>
        <div class="row mb-3 mt-3 pl-3 pr-3">
          <span class="section-disclaimer">
            HTML markup
          </span>
          <div class="select-wrap h-auto">
            <!-- eslint-disable -->
            <textarea class="select-wrap-textarea form-control script-template" rows="8" ref="formHtml" @click="copyHTML">
              &lt;!-- this goes inside the &lt;head&gt; tag on your page --&gt;
              &lt;link rel=&quot;stylesheet&quot; href=&quot;https://cdn.jsdelivr.net/npm/flatpickr/dist/flatpickr.min.css&quot;&gt;
              &lt;div class=&quot;container-fluid flex-column d-flex mod-wrapper&quot;&gt;
                &lt;div class=&quot;d-flex justify-content-center align-items-center mt-4 mb-3&quot;&gt;
                  &lt;div class=&quot;image&quot;&gt;
                    &lt;img src=&quot;https://widget.24mod.com/mod_form.png&quot; alt=&quot;form image&quot; width=&quot;250&quot; /&gt;
                  &lt;/div&gt;
                &lt;/div&gt;
                &lt;div id=&quot;mod-heading&quot; class=&quot;mod-heading mt-5 mb-2&quot;&gt;
                  Get a quote for your move
                &lt;/div&gt;
                &lt;div id=&quot;mod-form&quot; class=&quot;mod-form&quot;&gt;
                  &lt;form autocomplete=&quot;off&quot; id=&quot;postData&quot;&gt;
                    &lt;div class=&quot;row mb-2 mt-1&quot;&gt;
                      &lt;div class=&quot;col-6 pr-0&quot;&gt;
                        &lt;div class=&quot;mod-select-wrap&quot;&gt;
                          &lt;label class=&quot;mod-label&quot;&gt;Phone&lt;/label&gt;
                          &lt;input
                            id=&quot;mod_phone&quot;
                            type=&quot;text&quot;
                            autocomplete=&quot;off&quot;
                            class=&quot;mod-form-control&quot;
                            placeholder=&quot;Enter phone number&quot;
                          /&gt;
                        &lt;/div&gt;
                      &lt;/div&gt;
                      &lt;div class=&quot;col-6&quot;&gt;
                        &lt;div class=&quot;mod-select-wrap&quot;&gt;
                          &lt;label class=&quot;mod-label&quot;&gt;Email&lt;/label&gt;
                          &lt;input
                            id=&quot;mod_email&quot;
                            type=&quot;text&quot;
                            autocomplete=&quot;off&quot;
                            class=&quot;mod-form-control&quot;
                            placeholder=&quot;Enter email&quot;
                          /&gt;
                        &lt;/div&gt;
                      &lt;/div&gt;
                    &lt;/div&gt;
                    &lt;div class=&quot;row mb-2 mt-1&quot;&gt;
                      &lt;div class=&quot;col-6 pr-0&quot;&gt;
                        &lt;div class=&quot;mod-select-wrap&quot;&gt;
                          &lt;label class=&quot;mod-label&quot;&gt;First name&lt;/label&gt;
                          &lt;input
                            id=&quot;mod_first_name&quot;
                            type=&quot;text&quot;
                            autocomplete=&quot;off&quot;
                            class=&quot;mod-form-control&quot;
                            placeholder=&quot;Enter first name&quot;
                          /&gt;
                        &lt;/div&gt;
                      &lt;/div&gt;
                      &lt;div class=&quot;col-6&quot;&gt;
                        &lt;div class=&quot;mod-select-wrap&quot;&gt;
                          &lt;label class=&quot;mod-label&quot;&gt;Last name&lt;/label&gt;
                          &lt;input
                            id=&quot;mod_last_name&quot;
                            type=&quot;text&quot;
                            autocomplete=&quot;off&quot;
                            class=&quot;mod-form-control&quot;
                            placeholder=&quot;Enter last name&quot;
                          /&gt;
                        &lt;/div&gt;
                      &lt;/div&gt;
                    &lt;/div&gt;
                    &lt;div class=&quot;row mb-2 mt-1&quot;&gt;
                      &lt;div class=&quot;col-6 pr-0&quot;&gt;
                        &lt;div class=&quot;mod-select-wrap&quot;&gt;
                          &lt;label class=&quot;mod-label&quot;&gt;Move date&lt;/label&gt;
                          &lt;input
                            id=&quot;mod_move_date&quot;
                            type=&quot;date&quot;
                            autocomplete=&quot;off&quot;
                            class=&quot;mod-form-control&quot;
                            placeholder=&quot;Select move date&quot;
                          /&gt;
                        &lt;/div&gt;
                      &lt;/div&gt;
                      &lt;div class=&quot;col-6&quot;&gt;
                        &lt;div class=&quot;mod-select-wrap&quot;&gt;
                          &lt;label class=&quot;mod-label&quot; for=&quot;mod_move_size_id&quot;&gt;Move size&lt;/label&gt;
                          &lt;select class=&quot;mod-input-select&quot; id=&quot;mod_move_size_id&quot;&gt;
                            &lt;option value=&quot;1&quot;&gt;Studio&lt;/option&gt;
                            &lt;option value=&quot;2&quot;&gt;1 bedroom&lt;/option&gt;
                            &lt;option value=&quot;3&quot;&gt;2 bedrooms&lt;/option&gt;
                            &lt;option value=&quot;4&quot;&gt;3 bedrooms&lt;/option&gt;
                            &lt;option value=&quot;5&quot;&gt;4 bedrooms&lt;/option&gt;
                            &lt;option value=&quot;6&quot;&gt;4+ bedrooms&lt;/option&gt;
                            &lt;option value=&quot;7&quot;&gt;Small office&lt;/option&gt;
                            &lt;option value=&quot;8&quot;&gt;Medium office&lt;/option&gt;
                            &lt;option value=&quot;9&quot;&gt;Large office&lt;/option&gt;
                            &lt;option value=&quot;10&quot;&gt;Small storage (5x5, 5x8, 5x10)&lt;/option&gt;
                            &lt;option value=&quot;11&quot;&gt;Medium storage (10x10, 10x15)&lt;/option&gt;
                            &lt;option value=&quot;12&quot;&gt;Large storage (10x20)&lt;/option&gt;
                          &lt;/select&gt;
                        &lt;/div&gt;
                      &lt;/div&gt;
                    &lt;/div&gt;
                    &lt;div class=&quot;row mb-2 mt-1&quot;&gt;
                      &lt;div class=&quot;col-6 pr-0&quot;&gt;
                        &lt;div class=&quot;mod-select-wrap&quot;&gt;
                          &lt;label class=&quot;mod-label&quot;&gt;Pickup ZIP&lt;/label&gt;
                          &lt;input
                            id=&quot;mod_source_zip&quot;
                            type=&quot;text&quot;
                            autocomplete=&quot;off&quot;
                            class=&quot;mod-form-control&quot;
                            placeholder=&quot;Enter pickup ZIP&quot;
                          /&gt;
                        &lt;/div&gt;
                      &lt;/div&gt;
                      &lt;div class=&quot;col-6&quot;&gt;
                        &lt;div class=&quot;mod-select-wrap&quot;&gt;
                          &lt;label class=&quot;mod-label&quot;&gt;Delivery ZIP&lt;/label&gt;
                          &lt;input
                            id=&quot;mod_destination_zip&quot;
                            type=&quot;text&quot;
                            autocomplete=&quot;off&quot;
                            class=&quot;mod-form-control&quot;
                            placeholder=&quot;Enter delivery ZIP&quot;
                          /&gt;
                        &lt;/div&gt;
                      &lt;/div&gt;
                    &lt;/div&gt;
                    &lt;div class=&quot;row mb-2 mt-1&quot;&gt;
                      &lt;div class=&quot;col-6 pr-0&quot;&gt;
                        &lt;span /&gt;
                      &lt;/div&gt;
                      &lt;div class=&quot;col-6&quot;&gt;
                        &lt;input class=&quot;mod-submit-button&quot; type=&quot;submit&quot; value=&quot;Submit quote&quot; /&gt;
                      &lt;/div&gt;
                    &lt;/div&gt;
                  &lt;/form&gt;
                &lt;/div&gt;
                &lt;div id=&quot;mod-error&quot; class=&quot;alert alert-danger mod-hidden&quot; role=&quot;alert&quot;&gt;&lt;/div&gt;
                &lt;div id=&quot;mod-success&quot; class=&quot;mod-success mt-5 mod-hidden&quot;&gt;
                  &lt;div class=&quot;mod-success-content&quot;&gt;
                    &lt;p&gt;
                      Your request was submitted!
                    &lt;/p&gt;
                    &lt;p&gt;
                      You can expect a quote from our sales representatives shortly.
                    &lt;/p&gt;
                    &lt;br /&gt;
                    &lt;p&gt;
                      Have a great day!
                    &lt;/p&gt;
                  &lt;/div&gt;
                &lt;/div&gt;
              &lt;/div&gt;
              &lt;div class=&quot;mod-footer&quot;&gt;
                &lt;div class=&quot;mod-footer-content&quot;&gt;
                  powered by
                  &lt;a href=&quot;https://mod24.com/&quot; target=&quot;_blank&quot;&gt;
                    &lt;img class=&quot;pl-2&quot; src=&quot;https://widget.24mod.com/blue-2x 1.png&quot; alt=&quot;mod24 logo&quot; width=&quot;90&quot; /&gt;
                  &lt;/a&gt;
                &lt;/div&gt;
              &lt;/div&gt;
              &lt;script src=&quot;https://cdn.jsdelivr.net/npm/flatpickr&quot;&gt;&lt;/script&gt;
            </textarea>
            <!-- eslint-enable -->
          </div>
        </div>
        <div class="row mb-3 mt-3 pl-3 pr-3">
          <span class="section-disclaimer">
            Form logic
          </span>
          <div class="select-wrap h-auto">
            <!-- eslint-disable -->
            <textarea class="select-wrap-textarea form-control script-template" rows="8" ref="formScript" @click="copyScript">
              &lt;script&gt;
              document.getElementById('postData').addEventListener('submit', postData);

              document.getElementById('mod_phone').addEventListener('input', (e) => {
                let x = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                e.target.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
              });

              flatpickr("#mod_move_date", {});

              function postData(event){
                event.preventDefault();

                let phone = document.getElementById('mod_phone').value;
                let email = document.getElementById('mod_email').value;
                let first_name = document.getElementById('mod_first_name').value;
                let last_name = document.getElementById('mod_last_name').value;
                let move_date = document.getElementById('mod_move_date').value;
                let move_size_id = document.getElementById('mod_move_size_id').value;
                let source_zip = document.getElementById('mod_source_zip').value;
                let destination_zip = document.getElementById('mod_destination_zip').value;

                fetch('{{ url === 'production' ? 'https://api.mod24.com/api/v1/quotes' : 'https://rest.24mod.com/api/v1/quotes' }}', {
                  method: 'POST',
                  headers: {
                    "Content-Type": "application/json"
                  },
                  body: JSON.stringify({
                    company_key: {{ company.web_key }},
                    phone: phone,
                    email: email,
                    first_name: first_name,
                    last_name: last_name,
                    move_date: move_date,
                    move_size_id: move_size_id,
                    source_zip: source_zip,
                    destination_zip: destination_zip,
                  })
                })
                  .then((res) => {
                    if (!res.ok) {
                      document.getElementById("mod-error").classList.remove("mod-hidden");
                      document.getElementById("mod-error").innerHTML = "Sending information to server failed, try again?";
                      throw Error(res.statusText);
                    } else {
                      document.getElementById("mod-error").classList.add("mod-hidden");
                      let form = document.getElementById('mod-form');
                      let heading = document.getElementById('mod-heading');
                      let success = document.getElementById("mod-success");
                      form.classList.add("mod-hidden");
                      heading.classList.add("mod-hidden");
                      success.classList.remove("mod-hidden");
                    }
                    return res.json();
                  })
              }
              &lt;/script&gt;
            </textarea>
            <!-- eslint-enable -->
          </div>
        </div>
      </div>
      <div class="col-6">
        <h2 class="l-header-2">Instructions</h2>
        <br />
        <span class="section-disclaimer">
          Below you can find more details how to implement the form on your website.
        </span>
        <div class="row mb-3 mt-3 pl-3 pr-3">
          <div class="instructions">
            <ul>
              <li>
                Copy the HTML markup wherever you want your web quote form to appear on your page.
              </li>
              <li>
                Copy the JavaScript code to the bottom of your HTML markup, just above the <code>&lt;/body&gt;</code> tag,
                or inside of a dedicated JavaScript file which you would have to link to the file containing the form HTML markup.
                <br />
                <a href="https://www.w3schools.com/tags/att_script_src.asp" target="_blank">How to link JavaScript file to HTML.</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="row mt-3 pl-3 pr-3 d-flex justify-content-end">
          <div class="assistance" @click="$emit('setStepEditing')">
            Switch to simple button?
          </div>
        </div>
        <div class="row mt-3 pl-3 pr-3 d-flex justify-content-end">
          <div class="assistance" @click="$emit('setStepIframe')">
            Switch to iframe form?
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import toastr from 'toastr';

export default {
  props: {
    company: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    url: process.env.NODE_ENV,
  }),
  methods: {
    copyHTML() {
      this.$copyText(this.$refs.formHtml.defaultValue).then(() => {
        toastr.success('Copied HTML to clipboard');
      });
    },
    copyScript() {
      this.$copyText(this.$refs.formScript.defaultValue).then(() => {
        toastr.success('Copied script to clipboard');
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.select-wrap {
  width: 100%;
}
.script-template {
  height: 250px;
  overflow-y: scroll;
}
.instructions {
  height: 502px;
  overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/companies/CompaniesWebQuoteCustom.vue